import React, { FC } from 'react';
import { Box } from '@mui/material';
import Pill from '@ingka/pill';
import { updateFy } from '../../utils/calculation';

type CompactPillOverlayProps = {
  selectedValues: string[];
  maxDisplayItems: number;
};

const CompactPillOverlay: FC<CompactPillOverlayProps> = ({
  selectedValues,
  maxDisplayItems,
}) => {
  if (!selectedValues.length) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: 8,
        transform: 'translateY(-50%)',
        zIndex: 1,
        display: 'flex',
        gap: 0.5,
        pointerEvents: 'none',
      }}
    >
      <Pill
        size="xsmall"
        label={`${selectedValues[0]}-${updateFy(selectedValues[0], 2)}`}
      />
      {selectedValues.length > maxDisplayItems && (
        <Pill
          size="xsmall"
          label={`+${selectedValues.length - maxDisplayItems}`}
        />
      )}
    </Box>
  );
};

export default CompactPillOverlay;
